// 確定（作成・返信成功）時の軽いお祝い演出。星がパネル上で一度だけ弾ける。
// キャラ（まなパルくん）は使わない。

const STARS = [
  "top-2 left-8 type-md",
  "top-6 right-8 type-title",
  "top-0 left-1/2 type-body",
  "top-12 left-4 type-sm",
  "top-8 right-4 type-md",
];

export const SparkleBurst = () => (
  <div className="flex-col-el absolute inset-0 pointer-events-none">
    {STARS.map((cls, index) => (
      <span
        key={index}
        className={`material-symbols-filled absolute sparkle-burst text-puzzle-yellow ${cls}`}
      >
        star
      </span>
    ))}
  </div>
);
